module.exports = __webpack_public_path__ + "static/media/204-Kaffee_ID_30m.fd4b5349.mp3";